import isEqual from 'lodash-es/isEqual.js';
import { guidFast } from '../../utils.js';
/**
 * Returns a default configuration for a base filter.
 *
 * @internal
 */
export const getDefaultBaseFilterConfig = () => ({
    guid: guidFast(13),
    disabled: false,
    locked: false,
});
/**
 * Returns a default configuration for a members filter.
 *
 * @internal
 */
export const getDefaultMembersFilterConfig = () => (Object.assign(Object.assign({}, getDefaultBaseFilterConfig()), { excludeMembers: false, enableMultiSelection: true, deactivatedMembers: [] }));
/**
 * Checks whether the given configuration is a members filter configuration.
 *
 * @param config - The filter configuration.
 * @returns Whether the configuration is a members filter configuration.
 * @internal
 */
export function isMembersFilterConfig(config) {
    return 'excludeMembers' in config;
}
/**
 * Simplifies the filter configuration by removing default values.
 *
 * @param config - The filter configuration.
 * @returns The simplified filter configuration.
 * @internal
 */
export const simplifyFilterConfig = (config) => {
    const defaultConfig = isMembersFilterConfig(config)
        ? getDefaultMembersFilterConfig()
        : getDefaultBaseFilterConfig();
    // Filter out properties that match their default values
    return Object.fromEntries(Object.entries(config).filter(([key, value]) => !isEqual(value, defaultConfig[key])));
};
//# sourceMappingURL=filter-config-utils.js.map